import { useEffect, useState, useCallback } from 'react';

function getViewportWidth(): number {
  return Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  );
}

function getViewportHeight(): number {
  return Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  );
}

export const useViewportSize = () => {
  const [width, setWidth] = useState<number>(getViewportWidth());
  const [height, setHeight] = useState<number>(getViewportHeight());

  const onResize = useCallback(() => {
    setWidth(getViewportWidth());
    setHeight(getViewportHeight());
  }, [setWidth, setHeight]);

  useEffect(() => {
    window.addEventListener('resize', onResize, true);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return {
    width,
    height,
  };
};
